<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="pricingState; else handleNoPricingData">
      <div *ngIf="!pricingState.pricingConfig.hidePricingChart" edsSpacing="lg">
        <ft-pricing-chart
          [chartConfig]="pricingState.chartConfig"
          [minDateStd]="pricingState.pricingConfig.dateValues.incDateStd"
          [maxDateStd]="pricingState.pricingConfig.dateValues.asOfDateStd"
          [navAsOfDate]="pricingState.overviewData.nav.navAsOfDate"
          [performanceInceptionDateStd]="
            pricingState.overviewData.shareClass.performanceInceptionDateStd
          "
          [fundId]="brConfig.fundId"
          (toggleChartRangeUpdated)="updatePriceChart($event)"
        ></ft-pricing-chart>
      </div>
      <div *ngIf="showSharePrices">
        <div *ngIf="navData" edsSpacing="lg">
          <ft-share-prices
            [navData]="navData"
            [config]="pricingState.pricingConfig"
            [fundId]="brConfig.fundId"
          ></ft-share-prices>
        </div>
      </div>
      <div *ngIf="showPricingBreakpoints">
        <ft-pricing-breakpoints
          [navData]="navData"
          [salesChargeBreakPointsData]="salesChargeBreakPointsData"
          [fundId]="brConfig.fundId"
          [config]="pricingState.pricingConfig"
        ></ft-pricing-breakpoints>
      </div>
      <div *ngIf="showNavHighLow" edsSpacing="md">
        <ft-nav-high-low
          [navAsOfDate]="navData.navAsOfDate"
          [highLowNavTableData]="pricingState.highLowNavTableData"
          [fundId]="brConfig.fundId"
        ></ft-nav-high-low>
      </div>

      <div>
        <eds-accordion>
          <eds-accordion-item
            [title]="
              'products.price-view-historical-price-data'
                | translate: brConfig.fundId
            "
            [printable]="true"
          >
            <ft-pricing-historical
              [pricingState]="pricingState"
              [filteredHistoricalList]="filteredHistoricalList"
              [historicalTableTotalPages]="historicalTableTotalPages"
              [fundId]="brConfig.fundId"
              (toggleTableRangeUpdated)="updatePriceTable($event)"
              (selectedPage)="onPageChanged($event)"
              (downloadAction)="onDownloadButtonClicked()"
            ></ft-pricing-historical>
          </eds-accordion-item>
        </eds-accordion>
      </div>
    </div>

    <ng-template #handleNoPricingData>
      <span>{{ "products.price-no-data-error" | translate }}</span>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Pricing</h5>
</ng-template>
